import Link from "next/link";
import React from "react";
import { BiSolidChevronsRight } from "react-icons/bi";

export interface BreadcrumbItem {
  label: string;
  href?: string; // optional for the current page
}

interface BreadcrumbProps {
  title: string; // main page title
  items: BreadcrumbItem[];
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ title, items }) => {
  return (
    <div className="py-[10px] px-[20px] bg-gradient-to-l from-red-800">
      <div className="container mx-auto">
        <div className="flex justify-between xl:flex-row flex-col items-center">
          <h2 className="text-2xl font-extrabold text-center text-[#033b6f]">
            {title.split(" ")[0]}{" "}
            <span className="text-[#d42427]">{title.split(" ")[1]}</span>
          </h2>
          <ul className="flex items-center xl:gap-5 gap-2 mt-2 xl:mt-0">
            {items.map((item, index) => (
              <React.Fragment key={index}>
                <li>
                  {item.href ? (
                    <Link href={item.href} className="text-white font-semibold">
                      {item.label}
                    </Link>
                  ) : (
                    <span className="text-white font-semibold">{item.label}</span>
                  )}
                </li>
                {index < items.length - 1 && (
                  <li>
                    <BiSolidChevronsRight
                      size={12}
                      className="opacity-35 text-white"
                    />
                  </li>
                )}
              </React.Fragment>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Breadcrumb;
